module.exports = __webpack_public_path__ + "static/media/1.caac2220.jpg";